import type { TimeColumn, TimeUnit } from './timelineUtils';
import { CELL_WIDTH, ROW_HEIGHT } from './timelineUtils';

const DAY_LABELS = ['일', '월', '화', '수', '목', '금', '토'];

interface Props {
  columns: TimeColumn[];
  timeUnit: TimeUnit;
}

export default function GanttHeader({ columns, timeUnit }: Props) {
  const cellW = CELL_WIDTH[timeUnit];

  // day 모드: 2행 헤더 (날짜 + 요일)
  if (timeUnit === 'day') {
    return (
      <div
        className="sticky top-0 z-10 flex bg-gray-50 border-b"
        style={{ height: 42, minWidth: `${columns.length * cellW}px` }}
      >
        {columns.map((col, i) => {
          const dow = col.date.getDay();
          const isWeekend = dow === 0 || dow === 6;
          const dayColor = dow === 0 ? 'text-red-400' : dow === 6 ? 'text-blue-400' : 'text-gray-400';

          return (
            <div
              key={i}
              className={`flex-shrink-0 flex flex-col items-center justify-center border-r border-gray-200 ${
                col.isToday ? 'bg-red-50' : isWeekend ? 'bg-gray-100/50' : ''
              }`}
              style={{ width: `${cellW}px` }}
            >
              <span className={`text-sm leading-tight ${col.isToday ? 'font-semibold text-red-600' : 'text-gray-600'}`}>
                {col.label}
              </span>
              <span className={`text-[11px] leading-tight ${col.isToday ? 'font-semibold text-red-600' : dayColor}`}>
                {DAY_LABELS[dow]}
              </span>
            </div>
          );
        })}
      </div>
    );
  }

  // week/month 모드: 기존 1행 헤더
  return (
    <div
      className="sticky top-0 z-10 flex bg-gray-50 border-b"
      style={{ height: `${ROW_HEIGHT}px`, minWidth: `${columns.length * cellW}px` }}
    >
      {columns.map((col, i) => (
        <div
          key={i}
          className={`flex-shrink-0 flex flex-col items-center justify-center border-r border-gray-200 text-sm ${
            col.isToday ? 'bg-red-50 font-semibold text-red-600' : 'text-gray-500'
          }`}
          style={{ width: `${cellW}px` }}
        >
          <span>{col.label}</span>
          {col.subLabel && <span className="text-[11px] text-gray-400">{col.subLabel}</span>}
        </div>
      ))}
    </div>
  );
}
